<template>
  <div style="height: 100%" class="p-2">
    <vs-row style="align-items: center; margin-top: 5px">
      <!-- {{ pump_id }}{{ pump_station }} -->
      <h4 class="text_box2_1_1">{{ header }}</h4>
      <vs-spacer />
      <!-- <vs-button
        style="border-radius: 30px"
        color="warning"
        @click="popupActivo = true"
        type="filled"
        >Calibration</vs-button
      > -->
      <vs-button
        v-if="show_setting && pump_id != 'Rain'  && username !='FPSoperator'"
        radius
        color="warning"
        @click="call_value"
        type="flat"
        icon="compass_calibration"
      ></vs-button>
    </vs-row>
    <vs-popup class="holamundo" title="Calibration" :active.sync="popupActivo">
      <vs-row vs-w="12">
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="6"
          vs-sm="6"
          vs-xs="6"
        >
          <vs-input label="Min" type="number" v-model="value_lv.min" />
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="6"
          vs-sm="6"
          vs-xs="6"
        >
          <vs-input label="Max" type="number" v-model="value_lv.max" />
        </vs-col>
        <!-- <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="3"
          vs-sm="4"
          vs-xs="12"
        >
          <h5 class="textSuccess"><b>17 °C</b></h5>
        </vs-col>  --> </vs-row
      ><br />
      <vs-row
        ><vs-spacer />
        <vs-button
          color="success"
          @click="submit_data"
          style="border-radius: 30px; width: 80px"
          type="filled"
          >Submit</vs-button
        >
        <vs-button
          class="ml-2"
          color="dark"
          @click="popupActivo = false"
          style="border-radius: 30px; width: 80px"
          type="flat"
          >Cancel</vs-button
        ></vs-row
      >
    </vs-popup>
    <div v-if="a" class="text_box2_1_2">
      <h1 class="text_box2_1_2_1">{{ value }}</h1>
      <h3 class="mt-1">(MSL)</h3>
    </div>
    <div v-else class="text_box2_1_23">
      <h4 align="center" class="text_box2_1_2_1">
        {{ value }}
      </h4>
      <div style="width: 100%">
        <sub class="smalltext bg-danger">mm.</sub>
      </div>
      <br /><br />
      <vs-row style="background: #fbfbfa">
        <ul style="list-style: none">
          <li>
            <h4>Rain month : {{ rain_month }} mm.</h4>
          </li>
          <li class="mt-2">
            <h4>Rain year : {{ rain_year }} mm.</h4>
          </li>
        </ul></vs-row
      >
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "header",
    "value",
    "a",
    "show_setting",
    "pump_id",
    "pump_station",
    "rain_year",
    "rain_month",
  ],
  data() {
    return {
      username: "",
      popupActivo: false,
      number: 0,
      value_lv: { max: 0, min: 0 },
    };
  },
  methods: {
    call_value() {
      this.popupActivo = true;
      let char = this.pump_id[this.pump_id.length - 1];
      this.$API
        .get(`lkb/calibrate/lkb_station${this.pump_station}/${char}`)
        .then((result) => {
          console.log(result);
          this.value_lv.max = result.data.max;
          this.value_lv.min = result.data.min;
        });
    },
    submit_data() {
      let body_command = {
        command: {
          Type: "Setting_2",
          Station: this.pump_station,
          Value: this.pump_id,
          Min: parseFloat(this.value_lv.min),
          Max: parseFloat(this.value_lv.max),
        },
      };
      console.log(body_command);
      this.$API
        .post(`lkb/command`, body_command)
        .then((result) => {
          console.log(result);
          this.popupActivo = false;
          this.$vs.notify({
            title: "Success",
            color: "success",
            position: "top-center",
            time: 6000,
            icon: "done",
          });
        })
        .catch((error) => {
          this.$vs.notify({
            title: "Error",
            text: "Please try again later.",
            icon: "warning",
            color: "danger",
          });
        });
    },
  },
  mounted() {
    this.username = this.$session.get("username");
  },
};
</script>

<style scoped>
.text_box2_1_1 {
  /* margin-left: 5px; */
  font-size: 1rem;
  /* position: absolute; */
  /* width: 100%; */
  /* margin-top: 20px; */
  font-weight: 600;
  color: #707070;
}
.text_box2_1_2 {
  display: grid;
  margin-top: 85px;
  /* position: absolute; */
  bottom: 0;
  width: 100%;
  color: white;
  justify-items: center;
}
.text_box2_1_2_1 {
  font-size: 4rem;
  font-weight: 600;
}
.smalltext {
  font-size: 1rem;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
  margin-right: 20px;
  /* bottom: -2.25em;
  left: -1em; */
}
.text_box2_1_23 {
  display: grid;
  margin-top: 75px;
  /* position: absolute; */
  bottom: 0;
  width: 100%;
  color: #66696b;
  justify-items: center;
}
@media only screen and (max-width: 700px) {
}
</style>